import React, { useState } from 'react';
import { Card, Table, Button } from 'react-bootstrap';

// Table data
import MembershipTableData from "./membership-details-data.json";

// icon
import Icon from '@mdi/react';
import { mdiSquareEditOutline, mdiTrashCanOutline } from '@mdi/js';
import FormModal from '../../../Utils/FormModal';

export default function MembershipDetails() {
    // Membership Table Data
    const [membershipData] = useState(MembershipTableData);

    // Edit modal
    const [formModalShow, setShowFormModal] = useState(false);
    const handleMembershipDetailsShow = () => setShowFormModal(true);
    const handleFormModalClose = () => setShowFormModal(false);
    const [membershipBenefitsButton, setMembershipBenefitsButton] = useState('discountPlan');

    const [inputData, setInputData] = useState({
        memberName: '',
        price: '',
        minBillAmt: '',
        applyBenefits: '',
        salesDate: '',
        startDate: '',
        endDate: '',
        validity: '',
        validityPeriod: '',
        credit: '',
        productBranch: '',
    });

    const handleInputChange = (index, field, value) => {
        setInputData({ ...inputData, [field]: value });
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        setShowFormModal(false);
    };

    const rows = [
        {
            columns: [
                { size: { xxl: 4 }, inputParentClass: 'custom-form-input-sm', label: 'Name', type: 'text', name: 'memberName', id: 'memberName', placeholder: 'Enter member name...', value: inputData.memberName, errormsg: '', },
                { size: { sm: 6, xxl: 4 }, inputParentClass: 'custom-form-input-sm', label: 'Price', type: 'text', name: 'price', id: 'price', placeholder: 'Enter price...', value: inputData.price, errormsg: '', },
                { size: { sm: 6, xxl: 4 }, inputParentClass: 'custom-form-input-sm', label: 'Min Bill Amt', type: 'text', name: 'minBillAmt', id: 'minBillAmt', placeholder: 'Enter bill amount...', value: inputData.minBillAmt, errormsg: '', },
                {
                    size: { sm: 6 }, inputParentClass: 'custom-form-input-sm', label: 'Apply Benefits', type: 'select', name: 'applyBenefits', id: 'applyBenefits', value: inputData.applyBenefits, errormsg: '',
                    options: [
                        { value: '', label: 'Same Invoice' },
                        { value: '1', label: 'One' },
                        { value: '2', label: 'Two' },
                        // ...Tax.map(item => ({ value: item.id, label: item.name }))
                    ],
                },
                { size: { sm: 6 }, inputParentClass: 'custom-form-input-sm', label: 'Sales Date', type: 'date', name: 'salesDate', id: 'salesDate', placeholder: 'DD/MM/YYYY', value: inputData.salesDate, errormsg: '', },
                { size: { sm: 6, xxl: 4 }, inputParentClass: 'custom-form-input-sm', label: 'Start Date', type: 'date', name: 'startDate', id: 'startDate', placeholder: 'DD/MM/YYYY', value: inputData.startDate, errormsg: '', },
                { size: { sm: 6, xxl: 4 }, inputParentClass: 'custom-form-input-sm', label: 'End Date', type: 'date', name: 'endDate', id: 'endDate', placeholder: 'DD/MM/YYYY', value: inputData.endDate, errormsg: '', },
                {
                    size: { sm: 6, xxl: 4 }, inputParentClass: 'custom-form-input-sm', label: 'Validity', type: 'select', name: 'validity', id: 'validity', value: inputData.validity, errormsg: '',
                    options: [
                        { value: '', label: 'Year' },
                        { value: '1', label: 'Month' },
                        { value: '2', label: '6 Month' },
                        // ...Tax.map(item => ({ value: item.id, label: item.name }))
                    ],
                },
                { size: { sm: 6, xxl: 4 }, inputParentClass: 'custom-form-input-sm', label: 'Validity Period', type: 'text', name: 'validityPeriod', id: 'validityPeriod', placeholder: 'Enter validity period...', value: inputData.validityPeriod, errormsg: '', },
                {
                    size: { sm: 6, xxl: 4 }, inputParentClass: 'custom-form-input-sm', label: 'Credits Applicable?', type: 'select', name: 'creditsApplicable', id: 'creditsApplicable', value: inputData.creditsApplicable, errormsg: '',
                    options: [
                        { value: '', label: 'No' }, { value: '1', label: 'Yes' }, { value: '2', label: 'Null' },
                        // ...Tax.map(item => ({ value: item.id, label: item.name }))
                    ],
                },
                { size: { sm: 6, xxl: 4 }, inputParentClass: 'custom-form-input-sm', label: 'Credit', type: 'text', name: 'credit', id: 'credit', placeholder: 'Enter credit...', value: inputData.credit, errormsg: '', },
                {
                    size: { xl: 6 }, inputParentClass: 'custom-form-input-sm', label: 'Branch', type: 'multiSelect', name: 'productBranch', id: 'productBranch', value: inputData.productBranch, errormsg: '',
                    options: [
                        { value: "All Branch", label: "All Branch" },
                        { value: "NSF Adajan", label: "NSF Adajan" },
                        { value: "NFS Parle Point", label: "NFS Parle Point" },
                        { value: "NFS Uniform", label: "NFS Uniform" },
                        { value: "NFS Warehouse", label: "NFS Warehouse" },
                    ],
                },
                {
                    size: { xl: 6 }, type: 'button', additionalClass: 'justify-content-end mb-3 mt-4',
                    buttons: [
                        { color: 'primary', id: 'saveMembershipDetails', text: 'Save', },
                        { color: 'secondary', id: 'cancelMembershipDetails', text: 'Cancel', }
                    ]
                },
            ]
        },
        {
            columns: [
                { size: { md: 6 }, tag: 'h5', type: 'normaltext', class: 'my-4', text: 'Membership Benefits', },
                {
                    size: { xl: 6 }, type: 'button', additionalClass: 'justify-content-end my-3',
                    buttons: [
                        { color: membershipBenefitsButton === 'discountPlan' ? 'primary' : 'light', id: 'buttonDiscountPlan', text: 'Discount plan', handleOnClick: () => setMembershipBenefitsButton('discountPlan') },
                        { color: membershipBenefitsButton === 'freeService' ? 'primary' : 'light', id: 'buttonFreeService', text: 'Free service', handleOnClick: () => setMembershipBenefitsButton('freeService') }
                    ]
                },
            ]
        },
        {
            rowClass: 'border p-2 rounded mb-3 ' + (membershipBenefitsButton === 'freeService' ? 'd-none' : ''),
            columns: [
                {
                    size: { sm: 6, xl: 4, xxl: 3 }, inputParentClass: 'custom-form-input-sm', label: 'Service Category', type: 'select', name: 'serviceCategory', id: 'serviceCategory', value: inputData.serviceCategory, errormsg: '',
                    options: [
                        { value: '', label: 'Service Category' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...Tax.map(item => ({ value: item.id, label: item.name }))
                    ],
                },
                {
                    size: { sm: 6, xl: 4, xxl: 3 }, inputParentClass: 'custom-form-input-sm', label: 'Service', type: 'select', name: 'service', id: 'service', value: inputData.service, errormsg: '',
                    options: [
                        { value: '', label: 'Select Service' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...Tax.map(item => ({ value: item.id, label: item.name }))
                    ],
                },
                {
                    size: { sm: 6, xl: 4, xxl: 3 }, inputParentClass: 'custom-form-input-sm', label: 'Service Price', type: 'select', name: 'servicePrice', id: 'servicePrice', value: inputData.servicePrice, errormsg: '',
                    options: [
                        { value: '', label: 'No' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...Tax.map(item => ({ value: item.id, label: item.name }))
                    ],
                },
                {
                    size: { sm: 6, xl: 4, xxl: 3 }, inputParentClass: 'custom-form-input-sm', label: 'Timing', type: 'select', name: 'timing', id: 'timing', value: inputData.timing, errormsg: '',
                    options: [
                        { value: '', label: 'Full Day' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...Tax.map(item => ({ value: item.id, label: item.name }))
                    ],
                },
                {
                    size: { sm: 6, xl: 4, xxl: 3 }, inputParentClass: 'custom-form-input-sm', label: 'Gender', type: 'select', name: 'gender', id: 'gender', value: inputData.gender, errormsg: '',
                    options: [
                        { value: '', label: 'Select gender' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...Tax.map(item => ({ value: item.id, label: item.name }))
                    ],
                },
                {
                    size: { sm: 6, xl: 4, xxl: 3 }, inputParentClass: 'custom-form-input-sm', label: 'Benefits for Specific Days', type: 'select', name: 'benefitsforSpecificDays', id: 'benefitsforSpecificDays', value: inputData.benefitsforSpecificDays, errormsg: '',
                    options: [
                        { value: '', label: 'No' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...Tax.map(item => ({ value: item.id, label: item.name }))
                    ],
                },
                {
                    size: { sm: 6, xl: 4, xxl: 3 }, inputParentClass: 'custom-form-input-sm', label: 'Discount Type', type: 'select', name: 'discountType', id: 'discountType', value: inputData.discountType, errormsg: '',
                    options: [
                        { value: '', label: '%Off' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...Tax.map(item => ({ value: item.id, label: item.name }))
                    ],
                },
                {
                    size: { sm: 6, xl: 4, xxl: 3 }, inputParentClass: 'custom-form-input-sm', label: 'Discount Value', type: 'select', name: 'discountValue', id: 'discountValue', value: inputData.discountValue, errormsg: '',
                    options: [
                        { value: '', label: '0' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...Tax.map(item => ({ value: item.id, label: item.name }))
                    ],
                },
                {
                    size: { lg: 12 }, type: 'button', additionalClass: 'justify-content-end mb-2',
                    buttons: [
                        { color: 'primary', id: 'buttonSave', text: 'Save', },
                        { color: 'secondary', id: 'buttonCancel', text: 'Cancel', }
                    ]
                },
            ]
        },
        {
            rowClass: 'border pt-2 px-2 rounded',
            columns: [
                {
                    size: { sm: 6, xl: 4 }, inputParentClass: 'custom-form-input-sm', label: 'Service Category', type: 'select', name: 'fsServiceCategory', id: 'fsServiceCategory', value: inputData.fsServiceCategory, errormsg: '',
                    options: [
                        { value: '', label: 'All' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...Tax.map(item => ({ value: item.id, label: item.name }))
                    ],
                },
                {
                    size: { sm: 6, xl: 4 }, inputParentClass: 'custom-form-input-sm', label: 'Service Name', type: 'select', name: 'fsServiceName', id: 'fsServiceName', value: inputData.fsServiceName, errormsg: '',
                    options: [
                        { value: '', label: 'Select Name' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...Tax.map(item => ({ value: item.id, label: item.name }))
                    ],
                },
                { size: { sm: 6, xl: 4 }, inputParentClass: 'custom-form-input-sm', label: 'Free Visit', type: 'text', name: 'freeVisit', id: 'freeVisit', placeholder: 'Enter Free Visit...', value: inputData.freeVisit, errormsg: '', },
                {
                    size: { sm: 6, xl: 4 }, inputParentClass: 'custom-form-input-sm', label: 'Earning Type', type: 'select', name: 'earningType', id: 'earningType', value: inputData.earningType, errormsg: '',
                    options: [
                        { value: '', label: 'Full earning' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...Tax.map(item => ({ value: item.id, label: item.name }))
                    ],
                },
                { size: { sm: 6, xl: 4 }, inputParentClass: 'custom-form-input-sm', label: 'Earning(%)', type: 'text', name: 'earning', id: 'earning', placeholder: 'Enter Earning...', value: inputData.freeVisit, errormsg: '', },
                {
                    size: { sm: 6, xl: 4 }, type: 'button', additionalClass: 'justify-content-end mb-2 mt-4',
                    buttons: [
                        { color: 'primary', id: 'buttonSave', text: 'Save', },
                        { color: 'secondary', id: 'buttonCancel', text: 'Cancel', }
                    ]
                },
            ]
        }
    ];

    return (
        <>
            <div className='d-flex justify-content-between align-items-center mb-3'>
                <Card.Title className='mb-0'>Details</Card.Title>
                <div className='d-flex'>
                    <div className="btn-list">
                        <Button variant="soft-info p-0" onClick={handleMembershipDetailsShow}>
                            <div className='avatar avatar-sm'>
                                <Icon path={mdiSquareEditOutline} className='avatar-icon' />
                            </div>
                        </Button>{' '}
                        <Button variant="soft-danger p-0">
                            <div className='avatar avatar-sm'>
                                <Icon path={mdiTrashCanOutline} className='avatar-icon' />
                            </div>
                        </Button>{' '}
                    </div>
                </div>
            </div>

            {/* view membership */}
            <div className='view-membership'>
                <Table responsive className='table-lg border table-nowrap'>
                    <tbody>
                        {membershipData.membershipTableData.map((data, i) =>
                            <tr key={i}>
                                <th>{data.productheading1}</th>
                                <td>{data.productsubtext1}</td>
                                <th>{data.productheading2}</th>
                                <td>{data.productsubtext2}</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>

            {/* From Modal */}
            <FormModal title="Edit Membership" formModalShow={formModalShow} handleFormModalClose={handleFormModalClose} rows={rows} handleInputChange={handleInputChange} handleSubmit={handleSubmit} />
        </>
    )
}
